// Phone helpers shared across the app.
// Presentation: `(21) 99999-9999`  ·  Storage: `21999999999` (11 digits) or `5521999999999` (13 with DDI)

/** Strip everything but digits; drop the BR country code (`55`) when the user pastes it in;
 *  cap at 11 digits (BR mobile with DDD). */
export function sanitizePhone(v) {
  if (!v) return "";
  let d = String(v).replace(/\D/g, "");
  // If the user typed with the +55 country code (12–13 digits), drop the leading "55".
  if ((d.length === 12 || d.length === 13) && d.startsWith("55")) {
    d = d.slice(2);
  }
  return d.slice(0, 11);
}

/** Apply a Brazilian phone mask progressively as the user types. */
export function maskPhoneBR(v) {
  const d = sanitizePhone(v);
  if (d.length <= 2) return d;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** Ensure the number has the BR country code (`55`). Returns raw digits. */
export function withCountryCode(v) {
  const d = sanitizePhone(v);
  if (d.length === 10 || d.length === 11) return "55" + d;
  return d;
}
